module.exports = __webpack_public_path__ + "img/logo-cartao-de-todos.05a6f1be.png";